import { gsap } from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";
import ScrollToPlugin from "gsap/ScrollToPlugin";

gsap.registerPlugin(ScrollTrigger, ScrollToPlugin);

export default class Nav {
    constructor() {

        this.init();
        this.startX = 0;
        this.startY = 0;

    }

    init() {

        this.initShowHideNav();

        this.initNavSearch();
        this.initNavCart();
        this.initNavBurger();

        this.initResponsiveSubMenus();

        this.initSwipeListeners();

        this.attachAnchorListeners();
        this.scrollToAnchorOnLoad();

    }


    // === SHOW/HIDE NAV ===
    initShowHideNav() {
        const showhideNav = gsap.from('.nav-sticky', {
            opacity: 0,
            paused: true,
            duration: 0.5,
        }).progress(1);
        ScrollTrigger.create({
            start: 'top top',
            end: 99999,
            onUpdate: (self) => {
                const navSticky = document.querySelector('.nav-sticky');
                if (self.direction === -1) {
                    showhideNav.play();
                    navSticky.classList.add('has-bg');
                } else {
                    showhideNav.reverse();
                    navSticky.classList.add('has-scrolled');
                }
                const minScrollTop = document.body.classList.contains('admin-bar') ? 32 : 0;
                if (window.scrollY <= minScrollTop) {
                    navSticky.classList.remove('has-scrolled');
                    navSticky.classList.remove('has-bg');
                }
            },
        });
    }

    // === NAV SEARCH ===
    initNavSearch() {
        document.querySelectorAll(".nav-search").forEach(item => {
            item.addEventListener("click", () => {
                document.querySelector(".nav-search-modal").classList.toggle("active");
                document.documentElement.classList.toggle("block-viewport");
                document.body.classList.toggle("block-viewport");
            });
        });
        document.querySelectorAll(".nav-search-modal .search-close").forEach(item => {
            item.addEventListener("click", () => {
                document.querySelector(".nav-search-modal").classList.toggle("active");
                document.documentElement.classList.toggle("block-viewport");
                document.body.classList.toggle("block-viewport");
            });
        });
    }

    // === NAV CART ===
    initNavCart() {
        document.querySelectorAll(".nav-cart").forEach(item => {
            item.addEventListener("click", () => this.toggleCart());
        });
        document.querySelectorAll(".nav-cart-modal .cart-close, .nav-cart-overlay").forEach(item => {
            item.addEventListener("click", () => this.toggleCart());
        });
    }

    // === TOGGLE NAV CART / NAV CART OVERLAY / NAV RESPONSIVE
    toggleCart() {
        const navCartModal = document.querySelector(".nav-cart-modal");
        const navCartOverlay = document.querySelector(".nav-cart-overlay");
        const navResponsive = document.querySelector(".nav-responsive");
        const isCartModalActive = navCartModal.classList.contains("active");
        navCartModal.classList.toggle("active");
        navCartOverlay.classList.toggle("active");
        if (!isCartModalActive) {
            navResponsive.classList.remove("active");
            document.querySelector(".burger").classList.remove("active");
            document.documentElement.classList.add("block-viewport");
            document.body.classList.add("block-viewport");
        } else {
            if (!document.querySelector(".nav-search-modal.active")) {
                document.documentElement.classList.remove("block-viewport");
                document.body.classList.remove("block-viewport");
            }
        }
    }

    // === NAV BURGER ===
    initNavBurger() {
        document.querySelectorAll(".nav-burger, .nav-responsive-overlay").forEach(item => {
            item.addEventListener("click", () => {
                document.querySelector(".burger").classList.toggle("active");
                document.querySelector(".nav-responsive").classList.toggle("active");
                document.querySelector(".nav-responsive-overlay").classList.toggle("active");
                document.documentElement.classList.toggle("block-viewport");
                document.body.classList.toggle("block-viewport");
            });
        });
    }

    // === SWIPE NAV LISTENER ===
    initSwipeListeners() {
        const navResponsive = document.querySelector('.nav-responsive');
        const navCartModal = document.querySelector('.nav-cart-modal');
        if (navResponsive) {
            navResponsive.addEventListener('touchstart', (e) => this.handleTouchStart(e), false);
            navResponsive.addEventListener('touchmove', (e) => this.handleTouchMove(e, 'responsive'), false);
        }
        if (navCartModal) {
            navCartModal.addEventListener('touchstart', (e) => this.handleTouchStart(e), false);
            navCartModal.addEventListener('touchmove', (e) => this.handleTouchMove(e, 'cart'), false);
        }
    }

    handleTouchStart(e) {
        const firstTouch = e.touches[0];
        this.startX = firstTouch.clientX;
        this.startY = firstTouch.clientY;
    }

    handleTouchMove(e, type) {
        if (!this.startX || !this.startY) {
            return;
        }
        const moveEndX = e.touches[0].clientX;
        const moveEndY = e.touches[0].clientY;
        const diffX = this.startX - moveEndX;
        const diffY = this.startY - moveEndY;
        if (Math.abs(diffX) > Math.abs(diffY)) {
            if (diffX > 0 && type === 'responsive') {
                this.closeNavResponsive();
            } else if (diffX < 0 && type === 'cart') {
                this.toggleCart(false);
            }
        }
        this.startX = 0;
        this.startY = 0;
    }

    // === CLOSE NAV REPSONSIVE ===
    closeNavResponsive() {
        document.querySelector('.nav-responsive').classList.remove('active');
        document.querySelector('.burger').classList.remove('active');
        this.manageViewportBlock(false);
    }

    // === BLOCKVIEWPORT ===
    manageViewportBlock(shouldBlock) {
        if (shouldBlock) {
            document.documentElement.classList.add("block-viewport");
            document.body.classList.add("block-viewport");
        } else {
            if (!document.querySelector('.nav-cart-modal.active') && !document.querySelector('.nav-search-modal.active')) {
                document.documentElement.classList.remove("block-viewport");
                document.body.classList.remove("block-viewport");
            }
        }
    }

    // === RESPONSIVE SUB MENU ===
    initResponsiveSubMenus() {
        document.querySelectorAll(".nav-responsive ul.menu > li.menu-item-has-children > a").forEach(function(link) {
            link.addEventListener("click", function(e) {
                e.preventDefault();
                e.stopPropagation();
                const parentLi = this.closest("li");
                const subMenu = parentLi.querySelector("ul.sub-menu");
                if (getComputedStyle(subMenu).display !== "none") {
                    subMenu.style.display = "none";
                } else {
                    document.querySelectorAll(".nav-responsive ul.menu li ul.sub-menu").forEach(function(menu) {
                        menu.style.display = "none";
                    });
                    subMenu.style.display = "block";
                }
            });
        });
    }

    // === HREF HAVE ANCHOR ===
    attachAnchorListeners() {
        document.querySelectorAll('a[href^="#"]').forEach(anchor => {
            anchor.addEventListener('click', function(e) {
                e.preventDefault();
                const targetId = this.getAttribute('href');
                const targetElement = document.querySelector(targetId);
                if(targetElement) {
                    gsap.to(window, {
                        scrollTo: {
                            y: targetElement,
                            autoKill: false
                        },
                        duration: 1
                    });
                }
            });
        });
    }

    // === SCROLL TO ANCHOR ===
    scrollToAnchorOnLoad() {
        const hash = window.location.hash;
        if (hash) {
            const targetElement = document.querySelector(hash);
            if (targetElement) {
                gsap.to(window, {
                    scrollTo: {
                        y: targetElement,
                        autoKill: false
                    },
                    duration: 1,
                    delay: 0.25
                });
            }
        }
    }


}
